import { IconLock } from '@tabler/icons-react';

export interface ReadOnlyLockProps {
  size?: number;
  stroke?: number;
  color?: string;
}

/** Lock icon wrapped in a "Read only" tooltip — used as the right-section icon
 * of input components in the readonly+lock variant. */
export const ReadOnlyLock = ({
  size = 16,
  stroke = 2,
  color,
}: ReadOnlyLockProps) => <IconLock size={size} stroke={stroke} color={color} />;
